var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { portkeyInitEvent, portkeyInitEventV1 } from '@portkey/provider-types';
/**
 * This API provides a way to detect the provider object injected to the environment.
 * @param options - determine the timeout of the detection.
 * @returns A promise that resolves to the provider object, or null if the provider is not detected.
 * @see {@link IPortkeyProvider} provider type definition
 */
export default function detectProvider(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { timeout = 3000, providerName = 'Portkey' } = options || {};
        // window.portkey already exists
        if (window[providerName])
            return isPortkeyProvider(window[providerName]) ? window[providerName] : null;
        const eventName = isPortkeyV1(providerName) ? portkeyInitEventV1 : portkeyInitEvent;
        return new Promise((resolve, reject) => {
            let timedOut = false;
            const handlePortkey = () => {
                clearTimeout(timerId);
                window.removeEventListener(eventName, handlePortkey);
                if (isPortkeyProvider(window[providerName])) {
                    resolve(window[providerName]);
                }
                else {
                    if (timedOut) {
                        reject(new Error('Detect portkey provider timeout'));
                    }
                    else {
                        resolve(null);
                    }
                }
            };
            const timerId = setTimeout(() => {
                timedOut = true;
                handlePortkey();
            }, timeout);
            window.addEventListener(eventName, handlePortkey);
        });
    });
}
/**
 * This method is used to check if the provided object is a Portkey provider.
 * @param provider - the object that need to be checked
 * @returns provider is IPortkeyProvider
 */
export function isPortkeyProvider(provider) {
    return !!(provider &&
        typeof provider === 'object' &&
        'request' in provider &&
        'isPortkey' in provider &&
        provider.isPortkey);
}
export function isPortkeyV1(name) {
    return name === 'portkey';
}
//# sourceMappingURL=index.js.map